// src/dataProvider/resources/calendarFeeds.ts
import { httpClient } from "../../httpClient";
import { withGlobalClubFilter } from "../clubScope";

export function calendarFeedsResource(clubId: number | null) {
  return {
    getList: async (params: any) => {
      const paramsWithClub = withGlobalClubFilter(params, clubId);

      const page = paramsWithClub?.pagination?.page ?? 1;
      const perPage = paramsWithClub?.pagination?.perPage ?? 50;
      const field = paramsWithClub?.sort?.field ?? "id";
      const order = paramsWithClub?.sort?.order ?? "ASC";
      const filter = paramsWithClub?.filter ?? {};

      const qs = new URLSearchParams();

      // Backend erwartet page/perPage/sort/order (wie wir es gebaut haben)
      qs.set("page", String(page));
      qs.set("perPage", String(perPage));
      qs.set("sort", String(field));
      qs.set("order", String(order));

      // clubId (Filter überschreibt globalen clubId)
      if (filter?.clubId) qs.set("clubId", String(filter.clubId));
      else if (clubId) qs.set("clubId", String(clubId));

      if (filter?.q) qs.set("q", String(filter.q));

      const { json } = await httpClient(`/api/calendar-feeds?${qs.toString()}`);

      // Dein Backend liefert: { data: [...], total: n }
      const data = Array.isArray(json?.data) ? json.data : [];
      const total = typeof json?.total === "number" ? json.total : data.length;

      return { data, total };
    },

    getOne: async ({ id }: any) => {
      const { json } = await httpClient(`/api/calendar-feeds/${id}`);
      return { data: json?.data ?? json };
    },

    create: async (params: any) => {
      const payload = { ...params.data, club_id: clubId };
      const { json } = await httpClient(`/api/calendar-feeds`, {
        method: "POST",
        body: JSON.stringify(payload),
      });
      return { data: json?.data ?? json };
    },

    update: async ({ id, data }: any) => {
      const { json } = await httpClient(`/api/calendar-feeds/${id}`, {
        method: "PUT",
        body: JSON.stringify(data),
      });
      return { data: json?.data ?? json };
    },

    delete: async ({ id }: any) => {
      const { json } = await httpClient(`/api/calendar-feeds/${id}`, { method: "DELETE" });
      return { data: json?.data ?? { id } };
    },
  };
}
